import React, { memo, useCallback, useEffect, createElement, Fragment, FC } from 'react';
import classNames from 'classnames';
import Icon from 'atomic/icon';
import MenuListMobile from 'modules/shared/layout/menu/menu-mobile/components/menu-list-mobile';
import MenuInterface from 'modules/shared/layout/menu/interfaces/menu.interface';
import CustomTopMobile from 'modules/shared/layout/menu/components/custom-top/custom-top-mobile';
import useToggle from 'hooks/use-toggle';

import './menu-mobile.scss';

interface MenuMobileProps {
    onBack?: () => void;
    onClose: () => void;
    isOpen: boolean;
    title: string;
    menuList: MenuInterface[];
    url?: string;
    isCustomTop?: boolean;
    maxListItems?: number;
    level: number;
}

type Props = {
    className?: string;
};

const MenuMobile: React.FC<MenuMobileProps> = ({
    isOpen,
    onClose,
    url,
    title,
    menuList,
    onBack,
    maxListItems,
    isCustomTop = false,
    level
}) => {
    const [loadMenu, setLoadMenu] = useToggle();
    const [isHiddenListItems, setIsHiddenListItems] = useToggle();

    const onShowAllListItems = useCallback(() => {
        setIsHiddenListItems.setToggleState(false);
    }, [setIsHiddenListItems]);

    useEffect(() => {
        if (!loadMenu && isOpen) {
            setLoadMenu.setToggleState(isOpen);
        }

        if (isOpen && maxListItems && maxListItems < menuList.length) {
            setIsHiddenListItems.setToggleState(true);
        }
    }, [isOpen, maxListItems, menuList, setIsHiddenListItems]);

    return (
        <div
            className={classNames('menu-mobile', {
                'menu-mobile--open': isOpen
            })}
        >
            {loadMenu && (
                <div className="menu-mobile__header">
                    {onBack && (
                        <button
                            className="menu-mobile__button menu-mobile__button--back"
                            type="button"
                            onClick={onBack}
                            aria-label="Icon Back"
                        >
                            <Icon name="chevron-left" aria-hidden="true" color="dark" />
                        </button>
                    )}
                    <div className="menu-mobile__header-title">{title}</div>
                    <button
                        className="menu-mobile__button menu-mobile__button--close"
                        type="button"
                        onClick={onClose}
                        aria-label="Icon Close"
                    >
                        <Icon name="x" aria-hidden="true" color="dark" />
                    </button>
                </div>
            )}
            {createElement<Props>((loadMenu ? 'div' : Fragment) as FC, {
                className: 'menu-mobile__container'
            }, (
                <>
                    {loadMenu && url && (
                        <div className="menu-mobile__wrapper">
                            <div className="menu-mobile__title">{title}</div>
                            <a
                                className="menu-mobile__link"
                                title={title}
                                href={url}
                            >
                                Wszystkie produkty
                            </a>
                        </div>
                    )}
                    <MenuListMobile
                        list={menuList}
                        onClose={onClose}
                        maxItems={maxListItems}
                        onShowAll={!maxListItems ? undefined : onShowAllListItems}
                        isHidden={isHiddenListItems && loadMenu}
                        loadMenu={loadMenu}
                        level={level}
                    />
                    {isCustomTop && (
                        <CustomTopMobile />
                    )}
                </>
            ))}
        </div>
    );
};

export default memo(MenuMobile);
